export const LEAD_EXCEL_HEADERS = [
  {
    label: "Name",
    key: "inquiry.name",
  },
  {
    label: "Phone",
    key: "inquiry.phone",
  },
  {
    label: "State",
    key: "inquiry.state",
  },
  {
    label: "Created By",
    key: "create_by_name",
  },
  {
    label: "Lead Source",
    key: "inquiry.inquiry_type",
  },
  {
    label: "City",
    key: "inquiry.city",
  },
  {
    label: "Segments",
    key: "segment",
    render: (value) => {
      if (Array.isArray(value.segment)) {
        return value.segment.join(", ");
      }
      return value;
    },
  },
  {
    label: "Subscription Interest",
    key: "subscription_interest",
    fieldType: "bool",
  },
  {
    label: "Plan Interest",
    key: "plan_interest",
  },
  {
    label: "TA Interest",
    key: "ta_interest",
    fieldType: "bool",
  },
  {
    label: "Last Remark",
    key: "last_remark",
  },
  {
    label: "Last Remark By",
    key: "last_remark_by",
  },
  {
    label: "Last Remark Date",
    key: "last_remark_time",
    fieldType: "date",
  },
  {
    label: "Follow Up Date",
    key: "follow_up_date",
    fieldType: "date",
  },
  {
    label: "Not Interested Reason",
    key: "not_interested_reason",
  },
  {
    label: "Lead Closed",
    key: "is_lead_closed",
    fieldType: "bool",
  },
];
